var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 16,
    viewBox: "0 0 16 16",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8 1.601562c-1.582031 0-3.039062.578126-4.15625 1.53125-.152344.121094-.226562.316407-.191406.507813.03125.195313.167968.351563.351562.414063s.390625.019531.53125-.109376c.933594-.796874 2.140625-1.277343 3.464844-1.277343 2.773438 0 5.039062 2.097656 5.308594 4.796875h-1.574219l2.132813 3.203125 2.132812-3.203125h-1.628906c-.269532-3.277344-3.023438-5.863282-6.371094-5.863282zm-5.867188 3.730469-2.132812 3.203125h1.628906c.269532 3.277344 3.023438 5.863282 6.371094 5.863282 1.582031 0 3.039062-.578126 4.15625-1.53125.152344-.121094.226562-.316407.191406-.507813-.03125-.195313-.167968-.351563-.351562-.414063s-.390625-.019531-.53125.109376c-.933594.796874-2.140625 1.277343-3.464844 1.277343-2.773438 0-5.039062-2.097656-5.308594-4.796875h1.574219zm0 0",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReload);
export default __webpack_public_path__ + "static/media/reload.078c6887.svg";
export { ForwardRef as ReactComponent };